import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import router from './router/router.js'
// import axios from 'axios'
import http from './router/http'
import qs from 'qs'
import {localData, sessionData} from "../src/storage/storage"
import cookie from 'vue-cookie'
import Meta from 'vue-meta'
// 引入echarts
import echarts from 'echarts'
import VirtualCollection from 'vue-virtual-collection'
import Router from 'vue-router'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.prototype.axios = http
Vue.prototype.qs = qs           
Vue.prototype.localData = localData;
Vue.prototype.sessionData=sessionData;
Vue.prototype.$cookie = cookie
Vue.use(Meta)
Vue.prototype.$echarts = echarts 

Vue.use(VirtualCollection)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'projectName' || key === 'userName' || key === 'avatar') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}
Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
